module.exports = __webpack_public_path__ + "70a0310bb3b801c178883bdf79dcb2ea.svg";